import type { FC } from 'react';
import { Digits } from '@/shared/Digits';
import { rateToPercent } from './rate';

export const FeeRate: FC<{
  value?: string | null;
  className?: string;
}> = ({ value, className }) => (
  <Digits value={rateToPercent(value) ?? null} unit="%" className={className} />
);
